import React, { useEffect, useState } from 'react';
import {
    fetchNotifications,
    sendPushNotification,
    sendNotificationToSpecificUsers,
    resendNotification
} from '../../js/services/admin-api'; // Adjusted imports
import { formatDateTime } from '../../utils/common';

const ITEMS_PER_PAGE = 15; // Set number of items per page
const DEFAULT_URL = window.location.origin;
const NotificationManagement = () => {
    const [title, setTitle] = useState('');
    const [body, setBody] = useState('');
    const [isPromotion, setIsPromotion] = useState(false);
    const [isSpecificUsers, setIsSpecificUsers] = useState(false);    
    const [specificUrl, setSpecificUrl] = useState(DEFAULT_URL);
    const [userIds, setUserIds] = useState(''); // State for user ID input
    const accessToken = localStorage.getItem('accessToken');
    const [notifications, setNotifications] = useState([]); 
    
    // State for search inputs
    const [searchTitle, setSearchTitle] = useState('');
    const [searchBody, setSearchBody] = useState('');
    const [searchIsPromotion, setSearchIsPromotion] = useState('');
    const [searchIsSpecificUser, setSearchIsSpecificUser] = useState('');
    const [searchCreated, setSearchCreated] = useState(''); // New state for created date search
    const [searchSpecificUrl, setSearchSpecificUrl] = useState('');
    const [currentPage, setCurrentPage] = useState(1); // Pagination state

    const loadNotifications = async () => {
        try {
            const data = await fetchNotifications(accessToken);
            setNotifications(data);
        } catch (error) {
            console.error('Failed to load notifications:', error);
        }
    };

    useEffect(() => {
        loadNotifications();
    }, []);


    const handleSubmit = async (e) => {
        e.preventDefault();
        const validUserIds = validateUserIds(userIds);
        if (isSpecificUsers && !validUserIds) {
            alert("Please enter valid user IDs separated by commas, e.g., 1,2,3.");
            return;
        }
        await submitNotification(validUserIds);
        loadNotifications();
        clearForm();
    };

    const validateUserIds = (input) => {
        const userIdArray = input.split(',').map(id => id.trim());
        return userIdArray.every(id => /^\d+$/.test(id)) ? userIdArray : null;
    };

    const submitNotification = async (validUserIds) => {
        try {
            if (isSpecificUsers) {
                await sendNotificationToSpecificUsers(title, body, validUserIds, isPromotion, specificUrl, accessToken);
            } else {
                await sendPushNotification(title, body, isPromotion, specificUrl, accessToken);
            }
        } catch (error) {
            console.error('Error sending notification:', error);
        }
    };

    const handleResendNotification = async (notification) => {
        await resendNotification(notification.notification_id, accessToken);
        loadNotifications();
    };

    const clearForm = () => {
        setTitle('');
        setBody('');
        setIsPromotion(false);
        setIsSpecificUsers(false);
        setSpecificUrl(DEFAULT_URL);
        setUserIds(''); // Clear user ID input
    };
   
    // Filter notifications based on search criteria
    const filteredNotifications = notifications.filter(notification => {
        return (
            (searchTitle === '' || notification.title && notification.title.toLowerCase().includes(searchTitle.toLowerCase())) &&
            (searchBody === '' || notification.body && notification.body.toLowerCase().includes(searchBody.toLowerCase())) &&
            (searchIsPromotion === '' || (notification.isPromotion ? 'Yes' : 'No').includes(searchIsPromotion)) &&
            (searchIsSpecificUser === '' || (notification.isForSpecificUsers ? 'Yes' : 'No').includes(searchIsSpecificUser)) &&
            (searchCreated === '' || formatDateTime(notification.created_at).includes(searchCreated)) && // Check against created date
            (searchSpecificUrl === '' || notification.specificUrl && notification.specificUrl.toLowerCase().includes(searchSpecificUrl.toLowerCase()))
        );
    });

    // Calculate total pages
    const totalPages = Math.ceil(filteredNotifications.length / ITEMS_PER_PAGE);
    
    // Get current topics for the current page
    const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
    const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
    const currentRecords  = filteredNotifications.slice(indexOfFirstItem, indexOfLastItem);

    return (
        <div className="admin-container">
            <form onSubmit={handleSubmit}>
                <div className="notification_container">
                    <div className="input-row">
                        <input
                            className='notification_input'
                            type="text"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            placeholder="Enter notification title"
                            required
                        />
                        <textarea
                            className='notification_input'
                            value={specificUrl}
                            onChange={(e) => setSpecificUrl(e.target.value)}
                            placeholder="Enter specific Url"
                            required
                        />
                        <label className="input-row-label" style={{width:'30%'}}>
                            <input
                                style={{ opacity: 1 }}
                                type="checkbox"
                                checked={isPromotion}
                                onChange={() => setIsPromotion(!isPromotion)}
                            />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            Is Promotion
                        </label>
                    </div>
                    <div className="input-row">
                         <textarea style={{width:'100%'}}
                            className='notification_input'
                            value={body}
                            onChange={(e) => setBody(e.target.value)}
                            placeholder="Enter notification body"
                            required
                        />
                        <label className="input-row-label" style={{width:'180px'}}>
                            <input
                                style={{ opacity: 1 }}
                                type="checkbox"
                                checked={isSpecificUsers}
                                onChange={() => setIsSpecificUsers(!isSpecificUsers)}
                            />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            Is for Specific Users
                        </label>
                    </div>
                    {isSpecificUsers && (
                        <div className="input-row">
                            <input
                                className='notification_input'
                                type="text"
                                value={userIds}
                                onChange={(e) => setUserIds(e.target.value)}
                                placeholder="Enter user IDs, such as 1,2,3"
                                required={isSpecificUsers}
                            />
                        </div>
                    )}
                    <button type="button" onClick={clearForm}>Clear</button>
                    <button type="submit">Send</button>
                </div>
            </form>
            <table className="grade_table">
                <thead>
                    <tr>
                        <th>Actions</th>
                        <th>Notification Id</th>
                        <th>
                            Title
                            <input
                                type="text"
                                value={searchTitle}
                                onChange={(e) => setSearchTitle(e.target.value)}
                                placeholder="Search Title"
                                className="filter_input"
                            />
                        </th>
                        <th>
                            Body
                            <input
                                type="text"
                                value={searchBody}
                                onChange={(e) => setSearchBody(e.target.value)}
                                placeholder="Search Body"
                                className="filter_input"
                            />
                        </th>
                        <th>
                        Specific Url
                            <input
                                type="text"
                                value={searchSpecificUrl}
                                onChange={(e) => setSearchSpecificUrl(e.target.value)}
                                placeholder="Search Specific Url"
                                className="filter_input"
                            />
                        </th>
                        <th>
                            Is Promotion
                            <input
                                type="text"
                                value={searchIsPromotion}
                                onChange={(e) => setSearchIsPromotion(e.target.value)}
                                placeholder="Search Promotion"
                                className="filter_input"
                            />
                        </th>
                        <th>
                            Is For Specific User
                            <input
                                type="text"
                                value={searchIsSpecificUser}
                                onChange={(e) => setSearchIsSpecificUser(e.target.value)}
                                placeholder="Search Specific User"
                                className="filter_input"
                            />
                        </th>
                        <th>
                            Created
                            <input
                                type="text"
                                value={searchCreated}
                                onChange={(e) => setSearchCreated(e.target.value)}
                                placeholder="Search Created Date"
                                className="filter_input"
                            />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {currentRecords.map((notification) => (
                        <tr key={notification.notification_id}>
                             <td className="view" >
                                <a onClick={() => handleResendNotification(notification)}>Resend</a>
                            </td>
                            <td style={{ width: '10%' }}>{notification.notification_id}</td>
                            <td style={{ width: '20%' }}>{notification.title}</td>
                            <td style={{ width: '30%' }}>{notification.body}</td>
                            <td style={{ width: '10%' }}>{notification.specificUrl}</td>
                            <td style={{ width: '10%' }}>{notification.isPromotion ? 'Yes' : 'No'}</td>
                            <td style={{ width: '10%' }}>{notification.isForSpecificUsers ? 'Yes' : 'No'}</td>
                            <td style={{ width: '10%' }}>{formatDateTime(notification.created_at)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className="pagination">
                <button 
                    onClick={() => setCurrentPage(currentPage - 1)} 
                    disabled={currentPage === 1}
                >
                    Previous
                </button>
                <span>{currentPage} of {totalPages}</span>
                <button 
                    onClick={() => setCurrentPage(currentPage + 1)} 
                    disabled={currentPage === totalPages}
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default NotificationManagement;